import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface Turn {
  id?: string
  name: string
  code: string
  periodDays: string
  sucursal: string
  sucursalId: string
  is_inactive: boolean
  updated_at: string
}

export async function getTurns(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['sucursals.company_id = :companyId']
  if (search) {
    where.push(
      `CONCAT(turns.name,turns.code,sucursals.name) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN turns.code ~ '^[0-9]+$' THEN CAST(turns.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, turns.code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN turns.code ~ '^[0-9]+$' THEN CAST(turns.code AS numeric) ELSE NULL END), turns.code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_turns'],
    fields: [
      'turns.id',
      'turns.name',
      'turns.code',
      'turns.period_days',
      'turns.sucursal_id',
      'turns.is_inactive',
      'turns.updated_at',
      "CONCAT(sucursals.code,' - ',sucursals.name) as sucursal"
    ],
    where,
    join: ['INNER JOIN sucursals ON turns.sucursal_id = sucursals.id'],
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getTurn(id: string): Promise<Turn> {
  const data = await getData<any>({
    tables: ['pg_turns'],
    fields: [
      'turns.id',
      'turns.name',
      'turns.code',
      'turns.period_days as periodDays',
      'turns.sucursal_id as sucursalId',
      'turns.is_inactive',
      'turns.updated_at',
      'sucursals.name as sucursal',
      'turns.custom_fields as custom'
    ],
    where: [`turns.id = '${id}'`],
    join: ['INNER JOIN sucursals ON turns.sucursal_id = sucursals.id'],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createTurn(data: Turn): Promise<boolean> {
  const response: any = await http.post('payroll/turns', {
    sucursalId: data.sucursalId,
    name: data.name,
    code: data.code,
    periodDays: data.periodDays,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateTurn(data: Turn, id: string): Promise<boolean> {
  const response: any = await http.put('payroll/turns/' + id, {
    sucursalId: data.sucursalId,
    name: data.name,
    code: data.code,
    periodDays: data.periodDays,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteTurn(id: string): Promise<boolean> {
  const response: any = await http.delete('payroll/turns/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateStateTurn(
  id: string,
  enable: boolean
): Promise<boolean> {
  const response: any = await http.put('payroll/turns/' + id + '/enable', {
    enable
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
